import { ArticlePreviewResponse, getItemDisplayTitle, PublicCollectionResponse } from "@authory-packages/core";
import { EmbedTheme } from "../../utils/embeds";
import { getThumbnaiPlaceholderIcon } from "../ContentList/ContentList.utils";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { getItemUrl, ItemUrlContext } from "../V3ProfileList/V3ProfileList.utils";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3EmbedContentListItemImage, V3EmbedContentListItemImageTitle, V3EmbedContentListItemWrapper } from "./V3EmbedContentListitem.styles";
import { CLPlaceholderWrapper } from "../ItemImage/ItemImage.styles";
import { ItemMetadata } from "../ItemMetadata";
import { useContext } from "react";
import { DomainContext } from "../../context/domainContext";
import { RequestHost } from "../../types/headers";
import { isMainDomain } from "../../utils/domainRouting";

interface V3EmbedContentListItemProps {
    item: ArticlePreviewResponse;
    embedTheme: EmbedTheme;
    authorSlug: string;
    collection?: PublicCollectionResponse;
    context: ItemUrlContext;
}

export const V3EmbedContentListItem = ({ item, collection, embedTheme, authorSlug, context }: V3EmbedContentListItemProps) => {
    const requestHostHeader: RequestHost = useContext(DomainContext) ?? RequestHost.MAINDOMAIN;
    const mainDomain = isMainDomain(requestHostHeader);
    const itemUrl = getItemUrl(item, authorSlug, context, undefined, mainDomain, collection);

    const customBackgroundColor = embedTheme === EmbedTheme.light ? "#FFFFFF" : "#000000";

    return (
        <UnstyledLink href={itemUrl} target="_blank">
            <V3EmbedContentListItemWrapper>
                <div>
                    <V3EmbedContentListItemImage $imageSrc={item.thumbnailImage} aria-label={`Preview image of ${item.title}`}>
                        {!item.thumbnailImage && <CLPlaceholderWrapper>{getThumbnaiPlaceholderIcon(item.type)}</CLPlaceholderWrapper>}
                    </V3EmbedContentListItemImage>
                </div>
                <div>
                    <VerticalSpacing bottom={6}>
                        <ItemMetadata
                            item={item}
                            customDateFormat={"MMM dd, yyyy"}
                            showRedirect={false}
                            isEmbed
                            embedTheme={embedTheme}
                            hideFavicon
                            allowUserThemable
                            customBackgroundColor={customBackgroundColor}
                        />
                    </VerticalSpacing>
                    <V3EmbedContentListItemImageTitle $numLines={2} $embedTheme={embedTheme} $customBackgroundColor={customBackgroundColor}>
                        <strong>{getItemDisplayTitle(item)}</strong>
                    </V3EmbedContentListItemImageTitle>
                </div>
            </V3EmbedContentListItemWrapper>
        </UnstyledLink>
    );
};
